export default "/images/defaultBackgroundImage.png?c7b2e5edfcbc38a0d1405e27648829ce";